module.exports = __webpack_public_path__ + "img/PhonePeM.880ed193.png";